module.exports = __webpack_public_path__ + "img/saloon-v1-min.d535b447.jpg";